export enum ThemesEnum {
  DARK = 'dark',
  LIGHT = 'default'
}
